import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card card-custom",
  style: {"margin-top":"-30px"}
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "font-weight-bolder text-center display-4 text-fprimary" }
const _hoisted_7 = { class: "row justify-content-center mb-15" }
const _hoisted_8 = { class: "text-inicio text-center" }
const _hoisted_9 = { class: "row justify-content-center" }
const _hoisted_10 = { class: "col-5" }
const _hoisted_11 = {
  class: "card mb-3 w-100 border",
  style: {"background":"#EFF2F5"}
}
const _hoisted_12 = { class: "row align-items-center m-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "bi bi-folder2-open text-dark",
      style: {"font-size":"8rem"}
    })
  ])
], -1)
const _hoisted_14 = { class: "col-md-8" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "card-title" }
const _hoisted_17 = { class: "card-text" }
const _hoisted_18 = { class: "col-5" }
const _hoisted_19 = {
  class: "card mb-3 w-100 border",
  style: {"background":"#EFF2F5"}
}
const _hoisted_20 = { class: "row align-items-center m-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "bi bi-trophy text-dark",
      style: {"font-size":"8rem"}
    })
  ])
], -1)
const _hoisted_22 = { class: "col-md-8" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = { class: "card-title" }
const _hoisted_25 = { class: "card-text" }
const _hoisted_26 = { class: "col-5" }
const _hoisted_27 = {
  class: "card mb-3 w-100 border",
  style: {"background":"#EFF2F5"}
}
const _hoisted_28 = { class: "row align-items-center m-0" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "bi bi-clipboard-check text-dark",
      style: {"font-size":"8rem"}
    })
  ])
], -1)
const _hoisted_30 = { class: "col-md-8" }
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = { class: "card-title" }
const _hoisted_33 = { class: "card-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.t('home1')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('home2')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.t('home3')), 1),
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.t('home4')), 1),
                      _createVNode(_component_router_link, {
                        class: "btn btn-fsecondary text-white",
                        to: "planilla"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('clickHere')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("h5", _hoisted_24, _toDisplayString(_ctx.t('home5')), 1),
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.t('home6')), 1),
                      _createVNode(_component_router_link, {
                        class: "btn btn-fsecondary text-white",
                        to: "tournaments"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('clickHere')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("h5", _hoisted_32, _toDisplayString(_ctx.t('home7')), 1),
                      _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.t('home8')), 1),
                      _createVNode(_component_router_link, {
                        class: "btn btn-fsecondary text-white",
                        to: "support"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('clickHere')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}